import CreateApplicationTypeModel from './createApplicationTypeModel';

export default class CreateApplicationModel {
    AppName?: string
    AppDescription?: string
    oneSignalConfig?: Array<CreateApplicationTypeModel>
}
